export class EarningsDetail {
    category: string;
    type: string;
    name: string;
    amount: number;
  
    constructor(category: string, type: string, name: string, amount: number) {
      this.category = category;
      this.type = type;
      this.name = name;
      this.amount = amount;
    }
}
  


// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/points-estimate/earnings-detail.model.ts